var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86343 2.71468C10.648 2.71468 12.0946 4.16134 12.0946 5.94589V8.10003H5.63223V5.94589C5.63223 4.16135 7.07892 2.71468 8.86343 2.71468ZM3.47809 8.10003V5.94589C3.47809 2.97164 5.88924 0.560547 8.86343 0.560547C11.8377 0.560547 14.2488 2.97165 14.2488 5.94589V8.10003C16.0333 8.10003 17.48 9.54668 17.48 11.3312V19.9478C17.48 21.7324 16.0333 23.179 14.2488 23.179H3.47809C1.69351 23.179 0.246887 21.7324 0.246887 19.9478V11.3312C0.246887 9.54669 1.6935 8.10003 3.47809 8.10003ZM14.2488 10.2542C14.8436 10.2542 15.3258 10.7364 15.3258 11.3312V19.9478C15.3258 20.5426 14.8436 21.0248 14.2488 21.0248H3.47809C2.88321 21.0248 2.40102 20.5427 2.40102 19.9478V11.3312C2.40102 10.7364 2.88322 10.2542 3.47809 10.2542H14.2488ZM8.86343 13.4854C8.26859 13.4854 7.78637 13.9676 7.78637 14.5624V16.7166C7.78637 17.3114 8.26859 17.7936 8.86343 17.7936C9.45828 17.7936 9.9405 17.3114 9.9405 16.7166V14.5624C9.9405 13.9676 9.45828 13.4854 8.86343 13.4854Z",
    fill: "#3C5278"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0e261b1874016286943f2d5dad10abf3.svg";
export { ForwardRef as ReactComponent };